export default __webpack_public_path__ + "static/media/male_filter_icon.30347417.svg";